var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRetryTx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22.7499C6.80008 22.7499 2.58008 18.5199 2.58008 13.3299C2.58008 11.4599 3.13008 9.64989 4.17008 8.08989C4.40008 7.74989 4.87008 7.64989 5.21008 7.87989C5.55008 8.10989 5.65008 8.57989 5.42008 8.91989C4.55008 10.2199 4.09008 11.7499 4.09008 13.3199C4.09008 17.6899 7.64008 21.2399 12.0101 21.2399C16.3801 21.2399 19.9301 17.6899 19.9301 13.3199C19.9301 8.94989 16.3701 5.39989 12.0001 5.39989C11.0801 5.39989 10.1801 5.52989 9.33008 5.78989C8.93008 5.90989 8.51008 5.68989 8.39008 5.28989C8.27008 4.88989 8.49008 4.46989 8.89008 4.34989C9.89008 4.04989 10.9301 3.88989 12.0001 3.88989C17.2001 3.88989 21.4201 8.11989 21.4201 13.3099C21.4201 18.4999 17.2001 22.7499 12.0001 22.7499Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86987 6.07012C7.69987 6.07012 7.51987 6.01012 7.37987 5.89012C7.05987 5.61012 7.02987 5.14012 7.29987 4.83012L10.1899 1.51012C10.4599 1.20012 10.9399 1.16012 11.2499 1.44012C11.5599 1.71012 11.5899 2.19012 11.3199 2.50012L8.42987 5.81012C8.27987 5.98012 8.06987 6.07012 7.86987 6.07012Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2401 8.52988C11.0901 8.52988 10.9301 8.47988 10.8001 8.38988L7.42008 5.91988C7.09008 5.67988 7.02008 5.20988 7.26008 4.87988C7.50008 4.53988 7.97008 4.46988 8.31008 4.70988L11.6801 7.16988C12.0101 7.40988 12.0901 7.87988 11.8401 8.21988C11.7001 8.42988 11.4701 8.52988 11.2401 8.52988Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryTx);
export default __webpack_public_path__ + "static/media/retryTx.5281b67cda7d66855347db0d1a4e4faf.svg";
export { ForwardRef as ReactComponent };